import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import ReplyFeed from "./components/ReplyFeed";
import Reviews from "./components/Reviews";
import Scenes from "./components/Scenes";
import Channels from "./components/Channels";
import Faq from "./components/Faq";
import About from "./components/About";
import CtaBand from "./components/CtaBand";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <ReplyFeed />
        <Reviews />
        <Scenes />
        <Channels />
        <CtaBand />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}